import * as React from 'react'
import styled from '@emotion/styled'
import { FormattedMessage } from 'react-intl';


const StyledLocation = styled.div`
letter-spacing:1px !important;

  width: 80%;
  text-align:center;
margin:auto;
align-items:center;
justify-content: space-between;
font-family: "Theano Didot", Regular;
color:rgb(68, 68, 68);
padding-top:4%;

 @media screen and (max-width: 1200px) {
display:block;
   width:100%;
   }

`;

const IFrame = styled.iframe`
border:0;
margin-bottom:4.8%;

`

const PBold = styled.p`
font-family: "Theano Didot", Regular;
font-size: 1.3em;
font-weight:bold;
line-height: 1.5em;
color:rgb(68, 68, 68);
margin-right:1%;


  @media screen and (max-width: 1200px) {
margin-right:none;   }
`;

const P = styled.p`
font-family: "Theano Didot", Regular;
font-size: 1.3em;
line-height: 1.5em;
color:rgb(68, 68, 68);
margin-right:0.6%;
padding-left:0.5rem;

`;

const StyledP = styled.p`
font-family: "Theano Didot", Regular;
font-style: italic;
font-size: 160%;
text-align: right;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
width:25%;


`;

const Einzug = styled.p`
font-family: "Theano Didot", Regular;
font-size: 1.3em;
line-height: 1.5em;
color:rgb(68, 68, 68);
text-indent: 20px;
color:rgb(68, 68, 68);
margin-bottom:0;
`;



const Div = styled.div`
width:100%;

`

const HeadingDiv = styled.div`
width:100%;
display:flex;
justify-content:center;

  @media screen and (max-width: 1200px) {
display:block;   }
`

const TextBlock = styled.div`
width:100%;
display:flex;
justify-content: space-between;
margin-bottom:5%;

  @media screen and (max-width: 1200px) {
display:block;   }

`

const Text = styled.div`
width:30%;
text-align:left;
font-size: 1.11em;
line-height: 1.5em;

  @media screen and (max-width: 1200px) {
width:80%;
   margin-left:auto;
   margin-right:auto;
   padding-bottom:30px;
   }

`

const PHeading = styled.p`
font-family: "Theano Didot", Regular;
font-size: 1.1em !important;
font-weight:bold;
line-height: 1.5em;
color:rgb(68, 68, 68);
text-align:left;
margin-bottom:2%;
`;


interface LocationProps {
  className?: string
}

const Location: React.FC<LocationProps> = ({ }) => (
  <StyledLocation>
    <HeadingDiv>
   <PBold>Vilhelm7</PBold> <P>  Berlin Residences, Wilhelmstrasse 7, 10963 Berlin</P>
    </HeadingDiv>
    <Div>
      <IFrame
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2428.7812081242655!2d13.387241315502697!3d52.501199979810515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a8502b55a26d61%3A0xb49603e45b4e4684!2sVilhelm+7+Berlin+Residences!5e0!3m2!1sde!2sde!4v1550014024529"
        width="100%" height="490" frameBorder="0"  allowFullScreen></IFrame>
    </Div>


    <TextBlock>
<Text>
  <PHeading><FormattedMessage id="location_text_1" /></PHeading>
  <FormattedMessage id="location_text_6" />
</Text>
      <Text>

  <PHeading><FormattedMessage id="location_text_2" /></PHeading>

        <FormattedMessage id="location_text_7" />

      </Text>
      <Text>
  <PHeading><FormattedMessage id="location_text_3" /></PHeading>
        <FormattedMessage id="location_text_8" />
      </Text>

    </TextBlock>

    <TextBlock>
<Text>
  <PHeading><FormattedMessage id="location_text_4" /></PHeading>
  <FormattedMessage id="location_text_9" />
</Text>
      <Text>

  <PHeading><FormattedMessage id="location_text_5" /></PHeading>

        <FormattedMessage id="location_text_10" />

      </Text>
      <Text/>




    </TextBlock>



  </StyledLocation>

)

export default Location
